// EmojiPicker — a small grouped grid opened from the composer "+" menu. Picking
// inserts the glyph into the draft at the caret (see Composer); Escape/✕ closes.
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EMOJI_GROUPS } from '../emoji';

export const EmojiPicker: React.FC<{ onPick: (emoji: string) => void; onClose: () => void }> = ({ onPick, onClose }) => {
  const { t } = useTranslation('conversations');
  const [group, setGroup] = useState(EMOJI_GROUPS[0].key);
  const active = EMOJI_GROUPS.find((g) => g.key === group) ?? EMOJI_GROUPS[0];
  return (
    <div className="absolute bottom-full left-0 z-20 mb-2 w-72 rounded-xl border border-border bg-card p-2 shadow-lg" role="dialog" aria-label={t('emoji.title', { defaultValue: 'Emoji' })}>
      <div className="mb-1.5 flex items-center justify-between">
        <div className="flex gap-1 overflow-x-auto">
          {EMOJI_GROUPS.map((g) => (
            <button key={g.key} type="button" onClick={() => setGroup(g.key)} className={`rounded-full px-2 py-0.5 text-[11px] ${g.key === group ? 'bg-primary-50 text-primary-700 dark:bg-primary-500/15' : 'text-muted-foreground hover:bg-muted'}`}>
              {g.label}
            </button>
          ))}
        </div>
        <button type="button" onClick={onClose} className="ml-1 text-muted-foreground hover:text-charcoal" aria-label={t('close', { defaultValue: 'Close' })}>✕</button>
      </div>
      <div className="grid max-h-44 grid-cols-8 gap-0.5 overflow-y-auto">
        {active.emojis.map((e) => (
          <button key={e} type="button" onClick={() => onPick(e)} className="rounded p-1 text-lg leading-none hover:bg-muted" aria-label={e}>
            {e}
          </button>
        ))}
      </div>
    </div>
  );
};
